import { cloneElement } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

function Badge({
  icon,
  text,
  variant = 'icon-only',
  transparency = false,
  className = '',
  textSize = 'text-sm',
}) {
  const bg = transparency
    ? 'bg-event-badge-background/40'
    : 'bg-event-badge-background';

  if (variant === 'icon-only-rounded') {
    return (
      <div className="flex flex-row gap-1.5 items-center align-middle">
        <div className={clsx(bg, className, 'p-1.5 rounded-full')}>
          {cloneElement(icon, { className: 'text-event-text' })}
        </div>
        <h1 className="text-lg font-semibold text-event-text">{text}</h1>
      </div>
    );
  }

  if (variant === 'transparent') {
    return (
      <div
        className={clsx(
          className,
          'bg-transparent',
          'flex flex-row gap-1.5 items-center align-middle',
        )}
      >
        {cloneElement(icon, { className: 'text-event-text' })}
        <span className={clsx(textSize, 'font-bold text-event-text')}>
          {text}
        </span>
      </div>
    );
  }

  if (variant === 'full') {
    return (
      <div
        className={clsx(
          bg,
          className,
          'flex flex-row gap-1.5 items-center p-1.5 rounded-lg align-middle',
        )}
      >
        {cloneElement(icon, { className: 'text-event-text' })}
        <span className={clsx(textSize, 'font-bold text-event-text')}>
          {text}
        </span>
      </div>
    );
  }

  return (
    <div className="flex flex-row gap-1.5 items-center align-middle">
      <div className={clsx(bg, className, 'p-1 rounded-md')}>
        {cloneElement(icon, { className: 'text-event-text' })}
      </div>
      <span className={clsx('text-sm', className)}>{text}</span>
    </div>
  );
}

Badge.propTypes = {
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  transparency: PropTypes.bool,
  variant: PropTypes.oneOf(['icon-only-rounded', 'full', 'transparent']),
};

export default Badge;
